<div [id]="minimalMode ? '' : 'content-section'">
  <div [id]="minimalMode ? '' : 'content-main'" [ngClass]="{ 'responsive-content-main': !minimalMode }" [ngStyle]="{ 'margin-right': !minimalMode ? (sidebarMaximized ? '370px' : '270px') : '0px' }">
    <div id="content-sidebar" *ngIf="!minimalMode" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
          <a href="#" class="d-inline d-md-none text-dark" title="Close sidebar" (click)="sidebarOpen = false; $event.preventDefault()">
            <i class="fas fa-times"></i>
          </a>
        </small>
      </div>
      <div class="clearfix"></div>
      <div class="text-center pagination-small-margin pagination-center">
        <pagination [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="searchOptions.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
      <div class="text-center pt-1">
        <app-pagination-count
          [count]="count"
          singularName="Call"
          pluralName="Calls"
        ></app-pagination-count>
      </div>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="sticky-top bg-white">
        <h5 class="pt-2">
          <span>
            Search&nbsp;&nbsp;
            <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? pageChanged({ page: 1 }) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
          </span>
        </h5>
        <hr class="my-1" />
      </div>
      <div class="clearfix"></div>
      <div class="form-row">
        <div class="col">
          <label>User</label>
          <select class="form-control form-control-sm" name="user_id" [(ngModel)]="searchParams.user_id">
            <option value="">All</option>
            <option *ngFor="let user of searchOptions.users" [value]="user.id">{{ user.name }}</option>
          </select>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col">
          <label>Extension</label>
          <select class="form-control form-control-sm" name="extension" [(ngModel)]="searchParams.extension">
            <option value="">All</option>
            <option *ngFor="let extension of searchOptions.extensions">{{ extension }}</option>
          </select>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col">
          <label>Direction</label>
          <select class="form-control form-control-sm" name="direction" [(ngModel)]="searchParams.direction">
            <option value="">All</option>
            <option *ngFor="let dir of searchOptions.directions">{{ dir }}</option>
          </select>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col">
          <label>Result</label>
          <select class="form-control form-control-sm" name="result" [(ngModel)]="searchParams.result">
            <option value="">All</option>
            <option *ngFor="let res of searchOptions.results">{{ res }}</option>
          </select>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col">
          <label>Phone Number</label>
          <input type="text" class="form-control form-control-sm" name="phone_number" [(ngModel)]="searchParams.phone_number" placeholder="Search..." />
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col">
          <label>From</label>
          <input type="date" class="form-control form-control-sm" name="from_date" [(ngModel)]="searchParams.from_date" />
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col">
          <label>To</label>
          <input type="date" class="form-control form-control-sm" name="to_date" [(ngModel)]="searchParams.to_date" />
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col-6">
          <button type="button" class="btn btn-sm btn-primary btn-block" (click)="pageChanged({ page: 1 })" [disabled]="searching">
            {{ searching ? 'Searching' : 'Search' }}
            <span *ngIf="searching">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
          </button>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-sm btn-outline-secondary btn-block" (click)="clearSearch()" [disabled]="searching">
            Clear
          </button>
        </div>
      </div>
    </div>
    <div [id]="minimalMode ? '' : 'content-inner'" [ngClass]="{ 'responsive-content-inner': !minimalMode }" style="padding: 0px 20px 10px 20px">
      <div class="px-3 pb-4" [ngClass]="{ 'container-shadow': !minimalMode }">
        <h2 class="pt-4 text-center">
          Phone Calls
          <span *ngIf="minimalMode">
            <small><small><app-badge badgeType="primary">{{ count }}</app-badge></small></small>
          </span>
        </h2>
        <pagination *ngIf="minimalMode" [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="searchOptions.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
        <table class="table table-striped table-responsive-md table-sm table-hover" *ngIf="count > 0">
          <thead>
            <tr>
              <th style="cursor: pointer" (click)="sortBy('direction')">
                Direction <i class="fas" [ngClass]="sortIcon('direction')"></i>
              </th>
              <th style="cursor: pointer" (click)="sortBy('phone_number')">
                Ph. No. <i class="fas" [ngClass]="sortIcon('phone_number')"></i>
              </th>
              <th style="cursor: pointer" (click)="sortBy('contact_name')">
                Name <i class="fas" [ngClass]="sortIcon('contact_name')"></i>
              </th>
              <th style="cursor: pointer" (click)="sortBy('user_name')">
                User <i class="fas" [ngClass]="sortIcon('user_name')"></i>
              </th>
              <th style="cursor: pointer" (click)="sortBy('extension')">
                Ext. <i class="fas" [ngClass]="sortIcon('extension')"></i>
              </th>
              <th style="cursor: pointer" (click)="sortBy('start_time')">
                Start Time <i class="fas" [ngClass]="sortIcon('start_time')"></i>
              </th>
              <th style="cursor: pointer" (click)="sortBy('duration')">
                Minutes <i class="fas" [ngClass]="sortIcon('duration')"></i>
              </th>
              <th style="cursor: pointer" (click)="sortBy('result')">
                Result <i class="fas" [ngClass]="sortIcon('result')"></i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let call of phonecalls">
              <tr>
                <td>
                  <span *ngIf="(call.direction || call.call_type) === 'Inbound'" class="text-success"><i class="fas fa-arrow-down"></i> In</span>
                  <span *ngIf="(call.direction || call.call_type) === 'Outbound'" class="text-primary"><i class="fas fa-arrow-up"></i> Out</span>
                  <span *ngIf="(call.direction || call.call_type) === 'Missed'" class="text-danger"><i class="fas fa-phone-slash"></i> Missed</span>
                  <span *ngIf="!(call.direction || call.call_type)">-</span>
                </td>
                <td><a appPhoneCallBilling [phoneCallContactName]="call.contact_name || ''" [href]="'tel:' + call.phone_number" title="Call {{ call.phone_number }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ call.phone_number }}</a></td>
                <td>
                  <a *ngIf="call.contact_id" [routerLink]="['/contacts', call.contact_id]">{{ call.contact_name }}</a>
                  <span *ngIf="!call.contact_id">{{ call.contact_name }}</span>
                </td>
                <td>{{ call.user_name }}</td>
                <td>{{ call.extension }}</td>
                <td>{{ call.start_time }}</td>
                <td>{{ call.duration / 60 | number: '1.1-1' }}</td>
                <td>
                  <span *ngIf="call.result === 'Answered'" class="badge badge-success">Answered</span>
                  <span *ngIf="call.result === 'NoAnswer'" class="badge badge-danger">No Answer</span>
                  <span *ngIf="call.result === 'Busy'" class="badge badge-warning">Busy</span>
                  <span *ngIf="call.result === 'Voicemail'" class="badge badge-info">Voicemail</span>
                  <span *ngIf="call.result === 'Transferred'" class="badge badge-secondary">Transferred</span>
                  <span *ngIf="!call.result">
                    <span *ngIf="call.call_type === 'Missed'" class="badge badge-danger">Missed</span>
                    <span *ngIf="call.call_type === 'Inbound'" class="badge badge-success">Inbound</span>
                    <span *ngIf="call.call_type === 'Outbound'" class="badge badge-primary">Outbound</span>
                    <span *ngIf="call.call_type !== 'Missed' && call.call_type !== 'Inbound' && call.call_type !== 'Outbound'">{{ call.call_type }}</span>
                  </span>
                </td>
                <td>
                  <a href="javascript:void(0)" (click)="toggleDetail(call.id)" title="Details">
                    <i class="fas" [ngClass]="expandedCallId === call.id ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </a>
                </td>
              </tr>
              <tr *ngIf="expandedCallId === call.id" class="bg-light">
                <td colspan="9" class="py-2 px-3">
                  <div class="row">
                    <div class="col-md-4">
                      <small class="text-muted">Call ID:</small> <strong>{{ call.id }}</strong><br/>
                      <small class="text-muted">End Time:</small> {{ call.end_time || '-' }}<br/>
                      <small class="text-muted">Wait Time:</small> {{ call.wait_time ? (call.wait_time + 's') : '-' }}<br/>
                      <small class="text-muted">Call Type:</small> {{ call.call_type || '-' }}
                    </div>
                    <div class="col-md-4">
                      <small class="text-muted">Direction:</small> {{ call.direction || call.call_type || '-' }}<br/>
                      <small class="text-muted">Result:</small> {{ call.result || '-' }}<br/>
                      <small class="text-muted">CDR ID:</small> {{ call.cdr_id || '-' }}
                    </div>
                    <div class="col-md-4">
                      <small class="text-muted">Recording:</small>
                      <span *ngIf="call.recording_url"><a [href]="call.recording_url" target="_blank"><i class="fas fa-play-circle"></i> Play</a></span>
                      <span *ngIf="!call.recording_url">-</span><br/>
                      <small class="text-muted">Notes:</small> {{ call.notes || '-' }}<br/>
                      <small class="text-muted">Contact:</small>
                      <a *ngIf="call.contact_id" [routerLink]="['/contacts', call.contact_id]">{{ call.contact_name }}</a>
                      <span *ngIf="!call.contact_id">-</span>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="count === 0 && !searching" class="text-center text-muted py-4">
          No calls found.
        </div>
        <pagination *ngIf="minimalMode" [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="searchOptions.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
    </div>
  </div>
</div>
<app-sidebar-toggle-btn *ngIf="!minimalMode" [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
